import React, { useState, useCallback } from 'react';
import {
  Container, Row, Col, Button,
} from 'reactstrap';
import classnames from 'classnames';
import _ from 'lodash';
import {
  Intl, Form, TextField, ChangePasswordModal, FormItemRow, FormActionsBtns,
} from 'components';
import {
  composeValidators, email, required,
} from 'config/InputErrors';

const Profile = ( { data, isLoading, onSubmit } ) => {
  const [changePasswordModal, setChangePasswordModal] = useState( false );

  const toggleChangePasswordModal = useCallback( () => {
    setChangePasswordModal( ( state ) => !state );
  }, [] );

  return (
    <>
      <Container
        fluid
        className={classnames( { 'app-component-loading': isLoading } )}
      >
        <Form
          initialValues={data}
          showErrorsInHeader
          onSubmit={onSubmit}
          body={() => (
            <>
              <Row className="mb-1 mt-5">
                <Col>
                  {data.id
                    ? (
                      <Intl
                        // eslint-disable-next-line no-nested-ternary
                        id={data.id ? _.indexOf( data.roles, 'ROLE_CUSTOMER_ADMIN' ) !== -1 ? 'administrator' : 'user' : 'newUser'}
                      />
                    )
                    : <p />}
                </Col>
              </Row>
              <FormItemRow
                title="firstName"
                field={(
                  <TextField
                    field="firstName"
                    formGroupClass="m-0"
                    validate={required}
                  />
                )}
              />
              <FormItemRow
                title="lastName"
                field={(
                  <TextField
                    field="lastName"
                    formGroupClass="m-0"
                    validate={required}
                  />
                )}
              />
              <FormItemRow
                title="userEmail"
                field={(
                  <TextField
                    field="email"
                    formGroupClass="m-0"
                    validate={composeValidators( required, email )}
                    disabled
                  />
                )}
              />
              {/* <FormItemRow
                title="userSenderPhone"
                field={(
                  <Phone
                    field="phone"
                    formGroupClass="m-0"
                    validate={composeValidators( required, validPhone, validPhoneCountry )}
                  />
                )}
              /> */}
              {/* <FormItemRow
                title="language"
                fieldSize={2}
                field={(
                  <Select
                    field="language"
                    formGroupClass="m-0"
                    translateOptions
                    options={[
                      { id: 'es', name: 'spanishOptions' },
                    
                      { id: 'en', name: 'englishOption' },
                    ]}
                    validate={required}
                  />
                )}
                
              /> */}
              
              {/* <FormItemRow
                title="currency"
                fieldSize={2}
                field={(
                  <Select
                    field="currencyName"
                    formGroupClass="m-0"
                    translateOptions
                    options={[
                      { id: 'euro', name: 'euro' },
                      { id: 'dollar', name: 'dollar' },
                    ]}
                    validate={required}
                  />
                )}
              /> */}
              <Row>
                <Col md={3} className="pr-0">
                  <Button
                    color="app-default"
                    size="app-sm"
                    className="font-weight-700"
                    type="button"
                    block
                    onClick={toggleChangePasswordModal}
                  >
                    <Intl id="changePassword" />
                  </Button>
                </Col>
              </Row>
            </>
          )}
          footer={( <FormActionsBtns saveLabel="save" /> )}
        />
        {changePasswordModal
        && (
          <ChangePasswordModal
            entityId={data.id}
            open={changePasswordModal}
            onClose={toggleChangePasswordModal}
            onConfirm={toggleChangePasswordModal}
          />
        )}
      </Container>
    </>
  );
};


export default Profile;
